import {
  Dialog,
  DialogContent,
  Button,
  DialogContentText,
  DialogTitle,
  CircularProgress,
  Slide,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';

const CRInfoModal = (props) => {
  const isFromConnection = props.title === 'GSC_TEST_SITE' ? true : false;
  return (
    <Dialog
      PaperProps={{
        style: {
          width: props.modalWidth,
          maxWidth: props.modalWidth,
          borderRadius: '4px',
          marginTop: '-140px',
        },
      }}
      open={props.open}
      onClose={props.handleClose}
      className="cr-detail-modal"
    >
      <div style={{ position: 'absolute', right: '10px', top: '10px', cursor: 'pointer' }}>
        <CloseIcon onClick={props.handleClose} style={{ height: '18px', width: '18px' }} />
      </div>
      <DialogTitle className="title-header" style={{ marginTop: '12px', padding: '4px 24px' }}>
        {props.header}
      </DialogTitle>
      <DialogContent>
        <DialogContentText className="content-text">{props.content}</DialogContentText>
        {isFromConnection && (
          <div style={{ textAlign: 'center' }}>
            <Button className={`cr-info-modal-btn`} variant="contained" color="primary" onClick={props.handleClose}>
              Close
            </Button>
          </div>
        )}

        {props.buttontext && (
          <div style={{ textAlign: 'center', margin: '16px 0 11px 0px' }}>
            {!props.isloading && !props.isLoaderShow ? (
              <Button
                className={`cr-info-modal-btn`}
                style={{ textTransform: 'capitalize' }}
                variant="contained"
                color="primary"
                onClick={props.handleSubmit}
              >
                {props.buttontext}
              </Button>
            ) : (
              <CircularProgress size={24} color="inherit" />
            )}
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default CRInfoModal;
